import React, { useState } from "react";
import Storage from "../../utils/storage";

const VerifyStaff = () => {
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;
  let changePassword = Storage.get("staffPassword");

  const [state, setState] = useState({
    hidePrompt: true,
  });

  const hidePromptBar = () => {
    setState({
      ...state,
      hidePrompt: false,
    });
  };

  return (
    <div>
      {state.hidePrompt && userType === "staff" && changePassword === "null" ? (
        <div className="container-body2">
          <div className="error-bar">
            <span>Your default password has not been updated to a new one. To change, click <a href="/user/verify">here</a></span>
            <div
              data-testid="continue-sec"
              className="cancel-icon"
              onClick={() => hidePromptBar()}
            >
              X
          </div>
          </div>
        </div>
      ) : (
          <div></div>
        )}
    </div>
  );
};

export default VerifyStaff;
